<div [matTooltip]="'Select'" [matTooltipPosition]="'before'">
  <button
    mat-icon-button
    class="text-[18px]"
    [class.active]="active"
    [y42Permission]="state.isCanvasEditable"
    [permissionTooltip]="'You do not have permission to edit the asset'"
    [intercomTarget]="'toolbar-select-mode'"
    (click)="toggleSelectionMode.emit()"
  >
    <fa-icon [icon]="['fal', 'mouse-pointer']"></fa-icon>
  </button>
</div>
